var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSupportBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.99984 7.33333C1.2665 7.33333 0.666504 7.93333 0.666504 8.66667V13.3333C0.666504 14.0667 1.2665 14.6667 1.99984 14.6667C2.73317 14.6667 3.33317 14.0667 3.33317 13.3333V8.66667C3.33317 7.93333 2.73317 7.33333 1.99984 7.33333ZM13.3265 11.3333H8.77317C8.69984 11.3333 8.6265 11.32 8.55317 11.2933L7.57317 10.9533C7.39984 10.8933 7.31317 10.7067 7.37317 10.5333C7.43317 10.36 7.6265 10.2667 7.79984 10.3333L8.5465 10.62C8.61984 10.6467 8.7065 10.6667 8.7865 10.6667H10.5398C10.9732 10.6667 11.3265 10.3133 11.3265 9.88C11.3265 9.55333 11.1198 9.26 10.8132 9.14L6.19984 7.42C6.05317 7.36 5.89317 7.33333 5.73317 7.33333H4.6665V13.3467L8.91317 14.5533C9.1865 14.6333 9.47984 14.62 9.7465 14.52L14.6665 12.6667C14.6665 11.9267 14.0665 11.3333 13.3265 11.3333Z",
    fill: "#3367CD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3328 7.78333L10.8495 7.34333C9.13285 5.78667 7.99951 4.76 7.99951 3.5C7.99951 2.47333 8.80618 1.66667 9.83284 1.66667C10.4128 1.66667 10.9695 1.93667 11.3328 2.36333C11.6962 1.93667 12.2528 1.66667 12.8328 1.66667C13.8595 1.66667 14.6662 2.47333 14.6662 3.5C14.6662 4.76 13.5328 5.78667 11.8162 7.34667L11.3328 7.78333Z",
    fill: "#3367CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportBlue);
export default __webpack_public_path__ + "static/media/supportBlue.a213bfdb.svg";
export { ForwardRef as ReactComponent };